<template>
    <!-- 고객 검색 리스트 + 신규고객 등록 -->
    <div class="user_list_overlay" v-show="isShow">
        <!-- 유저 리스트-->
        <Item
            v-for="item in results" :key="item._id"
            :service="item"
            :focusedService="focusedService"
            :isShowRegistHService="isShowRegistHService"
            @setSelectedService="setSelectedService"
        />
        <RegistHService
            :isShow="isShowRegistHService"
            :newService="newService"
            @setSelectedService="setSelectedService"
            @closeRegistService="hideRegistHService"
        />
    </div>
</template>


<script>
import Item from './HServiceSearchResultItem.vue'
import RegistHService from './RegistHService/RegistHService.vue'

export default {
    components: { Item, RegistHService },
    props: {
        isShowRegistHService: Boolean,
        results: Array,
        focusedService: Object,
        keyword: String
    },
    data() {
        return {
            newService: undefined,
        }
    },
    watch: {
        results: {
            immediate: true,
            handler: function() {
                this.hideRegistHService()
                this.newService = undefined
            }
        }
    },
    computed: {
        isShow: function() {
            if (this.results == undefined) { return false }
            return true
        }
    },
    methods: {
        setSelectedService(service) {
            this.newService = undefined
            if (service.isNewHService == true) {
                this.newService = service
                this.showRegistHService()
            }
            else {
                this.$emit('setSelectedService', service)
            }
        },


        showRegistHService() {
            this.$emit('setIsShowRegistHService', true)
        },
        hideRegistHService() {
            this.$emit('setIsShowRegistHService', false)
        }
    }
}
</script>